import { createContext, useContext } from "react";

// Published by <FormGrid>. When active, RffInputWrapper places each field as a
// CSS-grid cell (spanning its `size` columns) instead of falling back to the
// legacy MUI <Grid item>. This is what lets Rff* fields drop into any parent:
// with a FormGrid ancestor they flow into columns, without one they stack
// full-width.
export const FormGridContext = createContext({ active: false, columns: 12 });

export const useFormGrid = () => useContext(FormGridContext);
